import vuetifyToast from 'vuetify-toast'
import { baseActions, baseMutations } from '../base'
import { apiAxios, parseFilters, parseSliderFilters } from '@/helpers'
import { formatDate } from '@/helpers/dateHelper'
import { getMatchFilters } from '@/helpers/permissions'
import i18n from '@/i18n/i18n'
// import moment from 'moment'
const paginate = () => ({
  hasMore: false,
  page: 1,
  rowsPerPage: 5,
  totalItems: 0,
})
const sliderTemplate = () => ({
  listObject: [],
  paginate: paginate(),
  filters: {},
  icon: '',
})
const notify = (message) => {
  vuetifyToast.show({
    text: message,
    color: 'success',
    timeout: 2000,
    icon: 'check',
  })
}
const lineUp = {
  items: [],
  groupByConvocation: {},
  groupByPositionType: {},
  groupByPosition: {},
  formation: '',
  primaryColor: '',
  secondaryColor: '',
  loading: false,
}
const initialState = () => {
  return {
    module: 'matches',
    model: 'match',
    loading: false,
    list: [],
    selectList: [],
    upcomingMatches: sliderTemplate(),
    lastMatches: sliderTemplate(),
    liveMatches: sliderTemplate(),
    simplified: {},
    selected: {
      active: true,
      type: '',
      date: '', // moment().format('YYYY-MM-DD'),
      tournamentId: '',
      categoryId: '',
      location: '',
      homeTeamId: '',
      homeTeamFormation: '',
      visitorTeamId: '',
      visitorTeamFormation: '',
      noRecord: false,
      recording: false,
      streamingAndRecording: true,
      bradcastId: '',
    },
    lineUp: {
      home: { ...lineUp },
      visitor: { ...lineUp },
    },
    idSelected: '',
    video: null,
    types: ['league', 'tournament', 'friendly'],
    filters: {
      playAs: 'all',
    },
    initialFilters: {
      playAs: 'all',
    },
    pagination: {
      hasMore: false,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
    },
  }
}

const state = initialState()

const getters = {
  matchTypes(state) {
    return state.types.map((item) => ({
      value: item,
      text: i18n.t(`fields.global.types.${item}`),
    }))
  },
  selectList(state) {
    return state.selectList
  },
  formatedList(state) {
    return state.list.map((item) => {
      let result = {
        ...item,
        type: i18n.t(`fields.global.types.${item.type}`),
        date: formatDate(item.date),
        createdAt: formatDate(item.createdAt, true),
      }

      // let wtzDate = getWtzDate(item)
      // if (item.date && moment(item.date).isValid()) {
      //   result.date = wtzDate.format('DD-MMM-YYYY')
      // }
      // // if (item.time && moment(item.time, 'HH:mm').isValid()) {
      // //   result.time = wtzDate.format('h:mm a')
      // // }
      return result
    })
  },
  liveMatches(state) {
    return state.liveMatches.map((item) => {
      let result = {
        ...item,
        type: i18n.t(`fields.global.types.${item.type}`),
        date: formatDate(item.date),
        category_tournament: '-',
      }
      if (item.type === 'tournament') {
        result.category_tournament = item.tournament
      } else {
        result.category_tournament = item.categories
      }

      // let wtzDate = getWtzDate(item)
      // if (item.date && moment(item.date).isValid()) {
      //   result.date = wtzDate.format('DD-MMM-YYYY')
      // }
      // if (item.time && moment(item.time, 'HH:mm').isValid()) {
      //   result.time = wtzDate.format('h:mm a')
      // }
      return result
    })
  },
}

const actions = {
  ...baseActions,
  async fetchOne({ dispatch, commit, state, rootState }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`${state.module}/${id}`)
      .finally(() => commit('setLoading', false))

    commit('setLoading', true)
    let promises = [
      dispatch(
        'matchEvents/fetchList',
        { matchId: id, type: 'all', userId: rootState.auth.user._id },
        { root: true }
      ),
      dispatch(
        'typeEvents/fetchSelectList',
        { type: ['user', 'official'] },
        { root: true }
      ),
    ]
    promises.push(dispatch('getMatchVideo', id))
    Promise.all(promises).finally(() => commit('setLoading', false))

    const item = data.data ? data.data[state.model] : {}
    commit('setOne', item)
    return item
  },
  async fetchEvents({ dispatch, commit, rootState }, id) {
    commit('setLoading', true)
    await dispatch(
      'matchEvents/fetchList',
      { matchId: id, type: 'all', userId: rootState.auth.user._id, limit: 0 },
      { root: true }
    ).finally(() => commit('setLoading', false))
  },
  async fetchSimplified({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(`${state.module}/${id}/simplified`)
      .finally(() => commit('setLoading', false))

    Promise.all([
      dispatch('getMatchVideo', id),
      dispatch('matchEvents/fetchList', { matchId: id }, { root: true }),
      dispatch(
        'typeEvents/fetchSelectList',
        { type: ['user', 'official'] },
        { root: true }
      ),
    ]).finally(() => commit('setLoading', false))

    const item = data.data ? data.data[state.model] : {}
    commit('setSimplified', item)
    return item
  },
  async fetchList({ commit, state, rootState, dispatch }, params = {}) {
    let { body, query } = parseFilters(state, params, getMatchFilters(params))
    if (state.filters.entityId && !state.filters.teamId && body.teamId) {
      // if searching by entity, get teams of that entity that are linked to me
      let filteredTeams = []
      let tmpTeams = await dispatch(
        'teams/fetchSelectList',
        {
          entityId: body.entityId,
        },
        { root: true }
      )
      filteredTeams = tmpTeams.filter((team) =>
        body.teamId.some((t) => t == team.value)
      )
      delete body.entityId
      body.teamId = { $in: filteredTeams.map((team) => team.value) }
    }

    if (rootState.tournaments.idSelected) {
      body.tournamentId = rootState.tournaments.idSelected
      dispatch('fetchSelectList', {
        ...params,
        tournamentId: rootState.tournaments.idSelected,
      })
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/format', body, { params: { ...query } })
      .finally(() => commit('setLoading', false))

    commit('setPagination', {
      totalItems: data.paginate ? data.paginate.totalData : 0,
    })

    const list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []
    commit('setList', list)
  },
  async fetchSelectList({ commit, state }, params = {}) {
    let set = true
    let query = {}
    if (params.set === false) {
      set = false
      delete params.set
    }
    let body = Object.assign({}, params, getMatchFilters(params))
    if (body.limit !== undefined) {
      query.limit = body.limit
      delete body.limit
    }
    commit('setLoading', true)
    const { data } = await apiAxios
      .post(state.module + '/select', body, { params: query })
      .finally(() => commit('setLoading', false))
    let list = data.data
      ? data.data[state.model] || data.data[state.module]
      : []

    list.forEach((item) => {
      item.date = formatDate(item.date)
    })
    if (set) commit('setSelectList', list)
    return list
  },
  async fetchSliders({ commit, state }, params = {}) {
    const slider = params.slider
    delete params.slider
    if (slider && !state[slider]) return

    let { body, query } = parseSliderFilters(
      state[slider].filters,
      state[slider].paginate,
      params,
      getMatchFilters(params)
    )
    query.admin = true
    if (slider) query.slider = slider

    const { data } = await apiAxios.post(state.module + '/all/sliders', body, {
      params: { ...query },
    })

    if (data.data && data.data.sliders && data.data.sliders.length) {
      data.data.sliders.forEach((slider) => {
        commit('setSlider', slider)
      })
    } else if (slider) {
      state[slider] = { ...sliderTemplate(), filters: state[slider].filters }
    }
  },
  async startMatch({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .post(state.module + '/start/' + id)
      .finally(() => {
        commit('setLoading', false)
      })
    dispatch('fetchOne', id).finally(() => {
      dispatch('fetchList')
    })
    notify(data.message)
  },
  async endMatch({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .post(state.module + '/end/' + id)
      .finally(() => {
        commit('setLoading', false)
      })
    dispatch('fetchOne', id).finally(() => {
      dispatch('fetchList')
    })
    notify(data.message)
  },
  async startStreaming({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .post(state.module + '/start_streaming/' + id)
      .finally(() => {
        commit('setLoading', false)
        dispatch('fetchOne', id).finally(() => {
          commit('setVideo')
          setTimeout(() => {
            dispatch('getMatchVideo', id)
          }, 10000)
        })
      })
    notify(data.message)
  },
  async endStreaming({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .post(state.module + '/end_streaming/' + id)
      .finally(() => {
        commit('setLoading', false)
        dispatch('fetchOne', id).finally(() => {
          dispatch('getMatchVideo', id)
        })
      })
    notify(data.message)
  },
  async getMatchVideo({ commit, state }, id) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .get(state.module + '/video/' + id)
      .finally(() => commit('setLoading', false))
    const video = data.data ? data.data.video : null
    if (!state.video || !video || video.src !== state.video.src) {
      commit('setVideo')
      setTimeout(() => {
        commit('setVideo', video)
      }, 1000)
    }
  },
  async fetchLiveMatches({ commit, state }, params = {}) {
    let body = Object.assign({}, params, getMatchFilters(params))
    let { data } = await apiAxios.post(state.module + '/live', body)
    const liveMatches = data.data ? data.data.matches : []
    commit('setLiveMatches', liveMatches)
  },
  async resetMatch({ dispatch, commit, state }, id) {
    commit('setLoading', true)
    let { data } = await apiAxios
      .post(state.module + '/reset/' + id)
      .finally(() => {
        commit('setLoading', false)
      })
    dispatch('fetchOne', id).finally(() => {
      dispatch('fetchList')
    })
    notify(data.message)
  },
  fetchLineUpList({ commit }, { matchId, teamType = 'home' }) {
    commit('setLineUpList', { teamType, loading: true })
    return apiAxios
      .get(`matches/${matchId}/lineUp/${teamType}`)
      .then(({ data }) => {
        if (!data.data) commit('resetLineUpList')
        else {
          let { lineUp, ...payload } = data.data
          commit('setLineUpList', {
            ...payload,
            items: lineUp,
            teamType,
          })
        }
      })
      .finally(() => commit('setLineUpList', { loading: false, teamType }))
  },
  async fetchLineUp(context, payload) {
    let { matchId, teamType, lineUpId } = payload
    let { data } = await apiAxios.get(
      `matches/${matchId}/lineUp/${teamType}/${lineUpId}`
    )
    let lineUp = data.data ? data.data['lineUp'] : {}
    return lineUp
  },
  async addLineUp({ dispatch }, payload) {
    let { matchId, teamType, ...params } = payload
    let { data } = await apiAxios.post(
      `matches/${matchId}/lineUp/${teamType}/add`,
      params
    )

    notify(data.message)
    dispatch('fetchLineUpList', { matchId, teamType })
  },
  async updateLineUp({ dispatch }, payload) {
    let { matchId, teamType, lineUpId, ...params } = payload
    let { data } = await apiAxios.put(
      `matches/${matchId}/lineUp/${teamType}/${lineUpId}`,
      params
    )

    notify(data.message)
    dispatch('fetchLineUpList', { matchId, teamType })
  },
  async deleteLineUp({ dispatch }, payload) {
    let { matchId, teamType, lineUpId } = payload
    let { data } = await apiAxios.delete(
      `matches/${matchId}/lineUp/${teamType}/${lineUpId}`
    )

    notify(data.message)
    dispatch('fetchLineUpList', { matchId, teamType })
  },
  async recoveryReady({ dispatch }, matchId) {
    await apiAxios.post(`matches/${matchId}/recovery-ready`)
    dispatch('fetchList')
  },
  async updateMatch(_, match) {
    await apiAxios.put(`matches-updated/add/${match._id}/${match.type}`)
  },
}

const mutations = {
  ...baseMutations,
  setSimplified(state, payload) {
    if (payload && typeof payload === 'object') {
      state.simplified = payload
      state.idSelected = payload._id
    }
  },
  setSlider(state, payload) {
    if (!payload || typeof payload !== 'object') return
    const slider = state[payload.typeSlider]
    if (!slider) return

    // List
    if (Array.isArray(payload.listObject)) {
      slider.listObject = payload.listObject.map((item) => ({
        ...item,
        type: i18n.t(`fields.global.types.${item.type}`),
        date: formatDate(item.date),
      }))
    }

    // Icon
    if ('icon' in payload) {
      slider.icon = payload.icon
    }

    // Pagination
    const paginate = payload.paginate || {}
    slider.paginate = {
      ...slider.paginate,
      page: paginate.page || 1,
      hasMore: paginate.hasMore || false,
      totalItems: paginate.totalData || 0,
    }
  },
  setLiveMatches(state, payload) {
    state.liveMatches = []
    if (Array.isArray(payload)) {
      payload.forEach((item) => state.liveMatches.push(item))
    }
  },
  setSliderFilters(state, payload) {
    if (payload && state[payload.slider]) {
      const slider = payload.slider
      delete payload.slider
      state[slider].filters = payload
    }
  },
  setSliderPagination(state, payload) {
    if (payload && state[payload.slider]) {
      const slider = payload.slider
      delete payload.slider
      state[slider].paginate = Object.assign(state[slider].paginate, payload)
    }
  },
  // eslint-disable-next-line no-unused-vars
  resetState(state) {
    const newState = initialState()
    Object.keys(state).forEach((key) => {
      delete state[key]
    })
    Object.assign(state, newState)
  },
  setLineUpList(state, payload) {
    const { teamType, ...item } = payload
    state.lineUp[teamType] = {
      ...state.lineUp[teamType],
      ...item,
    }
  },
  resetLineUpList(state, teamType) {
    state.lineUp[teamType] = initialState().lineUp[teamType]
  },
  reset(state) {
    state.selected = initialState().selected
    state.video = null
    state.idSelected = ''
    state.simplified = {}
    state.lineUp = initialState().lineUp
  },
  setVideo(state, payload) {
    state.video = payload
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
